<template>
    <b-card class="card-custom">
        <template v-slot:header>
            <h4 class="card-title">Общая информация</h4>
            <div class="card-toolbar">
                <b-button variant="white" class="button-icon-only mr-1" title="Обновить">
                    <i class="fa fa-sync"/>
                </b-button>
                <b-button variant="success">Сохранить</b-button>
            </div>
        </template>
        <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>
        <b-form>
            <b-form-group id="input-group-surname" label-cols="4" label-cols-lg="3"
                          label="Фамилия" label-for="input-surname">
                <b-form-input id="input-surname" v-model="userSurname" ref="inputSurname"/>
            </b-form-group>
            <b-form-group id="input-group-name" label-cols="4" label-cols-lg="3"
                          label="Имя" label-for="input-name">
                <b-form-input id="input-name" v-model="userName"/>
            </b-form-group>
            <b-form-group id="input-group-patronymic" label-cols="4" label-cols-lg="3"
                          label="Отчество" label-for="input-patronymic">
                <b-form-input id="input-patronymic" v-model="userPatronymic"/>
            </b-form-group>
            <b-form-group id="input-group-email" label-cols="4" label-cols-lg="3"
                          label="Email" label-for="input-email">
                <b-form-input id="input-email" v-model="email"/>
            </b-form-group>
            <b-form-group id="input-group-phone" label-cols="4" label-cols-lg="3"
                          label="Телефон" label-for="input-phone">
                <b-form-input id="input-phone" v-model="phone"/>
            </b-form-group>
        </b-form>
    </b-card>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

    export default {
        name: "AccountInformation",
        data() {
            return {
                userData: this.$store.getters.getUserData,

                err: false,
                errText: "",
                errVariant: "danger",

                userSurname: "",
                userName: "",
                userPatronymic: "",
                email: "",
                phone: "",
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.inputSurname.$el.focus()
            })
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
        }
    }
</script>

<style scoped>

</style>